import type { ReactNode } from "react";

import { AptosWalletAdapterProvider } from "@aptos-labs/wallet-adapter-react";
import { Network as AptosNetwork } from "@aptos-labs/ts-sdk";
import { APTOS_API_KEY } from "@/config/aptos";

const Web3Provider = ({ children }: { children: ReactNode }) => {
  return (
    <AptosWalletAdapterProvider
      autoConnect={true}
      dappConfig={{
        network: AptosNetwork.MAINNET,
        aptosApiKeys: APTOS_API_KEY,
      }}
      onError={(_error) => {}}
    >
      {children}
    </AptosWalletAdapterProvider>
  );
};

export default Web3Provider;
